import { useSelector } from 'react-redux';

const CNLogo = ({ textColor, isNavbar,type ,clickable}) => {
  const role_type = useSelector((store) => store?.userSubscription?.role_type);
  return (
    <div
      className="flex flex-row justify-center  rounded-lg px-1 pr-2 "
      style={{
        background: role_type!=='basic'&& role_type!==undefined  && type==='nav' ? 'linear-gradient(97.28deg, #FEED7F 0%, #CC8C04 100%)':'none',
      }}
    >
      <img
        className={`m-2 h-6 w-6 ${ clickable ? '' : 'cursor-pointer'} md:h-10 md:w-10`}
        src={'/img/learntubelogo.png'}
        alt="LearnTube"
      />
      <div
        className={`flex flex-col self-center text-${textColor} ${
          isNavbar && 'hidden md:flex'
        }`}
      >
        <span className="text-xs font-bold md:text-lg">LearnTube</span>
        <span className="text-supertiny font-semibold">by CareerNinja</span>
      </div>
    </div>
  );
};

export default CNLogo;

